import { Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthService } from '@auth0/auth0-angular';
import { UserSessionService } from '../../../../core/services/user-session.service';

@Component({
  selector: 'ms-sign-in',
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './sign-in.component.html'
})
export class SignInComponent implements OnInit {
  public signInForm!: FormGroup;
  public isLoading = false;
  public errorMessage = '';
  public showPassword = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private userSessionService: UserSessionService
  ) {}

  public ngOnInit(): void {
    this.userSessionService.clearLocalStorage();

    this.authService.isAuthenticated$.subscribe((isAuthenticated: boolean) => {
      if (isAuthenticated) {
        this.logIn();
      }
    });
  }

  public logIn(): void {
    sessionStorage.setItem('ms.auth.intent', 'sign-in-click');
    this.router.navigate(['/authenticate']);
  }
}

